import { apiFetch } from "./client";

export interface AppTemplate {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  framework: string | null;
  category: string;
  icon: string | null;
  repoUrl: string | null;
  scaffoldCommand: string | null;
  defaultEnvVars: Record<string, string> | null;
  requiredMcps: string[] | null;
  securityProfile: string;
  isPublic: boolean;
  sourceCompanyId: string | null;
  sourceAppId: string | null;
  installCount: number;
  status: string;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export const appTemplatesApi = {
  list: () =>
    apiFetch<AppTemplate[]>("/app-templates"),

  get: (id: string) =>
    apiFetch<AppTemplate>(`/app-templates/${id}`),

  create: (data: Partial<AppTemplate>) =>
    apiFetch<AppTemplate>("/app-templates", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id: string, data: Partial<AppTemplate>) =>
    apiFetch<AppTemplate>(`/app-templates/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),

  delete: (id: string) =>
    apiFetch<void>(`/app-templates/${id}`, { method: "DELETE" }),

  promote: (appId: string) =>
    apiFetch<AppTemplate>(`/app-templates/promote/${appId}`, {
      method: "POST",
    }),
};
